import { ActionIcon, Button, Stack, Tooltip } from "@mantine/core";
import { IconDotsVertical, IconSend } from "@tabler/icons-react";
import PopOver from "../../../../components/View/PopOver";
import DuplicateRessource from "../../../../components/View/DuplicateRessource";
import CopyToUser from "../../../../components/View/CopyToUser";
import { useLanguage } from "../../../../stores/LanguageStore";
import { getModelTypeProps, parseModelType } from "../modelUtils";
import { Link, useNavigate, useParams } from "react-router-dom";
import SendBAT from "../emails/SendBAT";
import ItemDeleter from "../../../../components/TableComponents/ItemDeleter";
import SelectionMover from "../../../../components/TableComponents/SelectionMover";
import SignatureLink from "./SignatureLink";
import ItemRemoveFromFolder from "../../../../components/TableComponents/ItemRemoveFolder";
import { useProfileStore } from "../../../../stores/UserStore";

const ModelActions = ({ current, inside = false, setLoading }) => {
  const lang = useLanguage((s) => s.language);
  const { modelType, modelId, folderId } = useParams();

  const navigate = useNavigate();
  const handleDeleteDone = (handleClose) => {
    if (modelId === current.id.toString()) {
      navigate(
        folderId
          ? `/models/folder/${folderId}/model/none/type`
          : `/models/${modelType}/none`,
      );
    }
    handleClose();
    setLoading(true);
  };

  return (
    <PopOver
      opener={(handleOpen, ref) =>
        inside ? (
          <Button
            ref={ref}
            variant="light"
            color="primary"
            leftSection={<IconDotsVertical size={18} />}
            radius={"sm"}
            ml={"auto"}
            onClick={handleOpen}
          >
            {lang.table.more_actions}
          </Button>
        ) : (
          <Tooltip label={lang.table.more_actions}>
            <ActionIcon
              variant="subtle"
              ref={ref}
              color="primary"
              onClick={handleOpen}
            >
              <IconDotsVertical size={18} />
            </ActionIcon>
          </Tooltip>
        )
      }
      popoverChildren={(handleClose) => (
        <Stack gap={0}>
          {modelType === "email" && <SendBAT inMoreActions model={current} />}

          <DuplicateRessource
            current={current}
            onFinish={() => setLoading(true)}
            closeMenu={handleClose}
            handler={
              getModelTypeProps(
                modelType === "type"
                  ? parseModelType(current.model_type)
                  : modelType,
              ).copyFunction
            }
            responseField={"model_id"}
          />

          <CopyToUser
            current={current}
            onFinish={() => handleClose()}
            closeMenu={handleClose}
            handler={
              getModelTypeProps(
                modelType === "type"
                  ? parseModelType(current.model_type)
                  : modelType,
              ).copyFunction
            }
            responseField={"model_id"}
          />

          {modelType === "email-signature" && (
            <SignatureLink
              current={current}
              onFinish={() => handleClose()}
              closeMenu={handleClose}
            />
          )}

          <SelectionMover
            handleEdit={
              getModelTypeProps(
                modelType === "type"
                  ? parseModelType(current.model_type)
                  : modelType,
              ).editFunction
            }
            onFinish={() => {
              setLoading(true);
              handleClose();
            }}
            ids={[current]}
            folderType={"Model"}
            isRowAction
          />

          {folderId && folderId !== "none" && (
            <ItemRemoveFromFolder
              title_bold={`${current.name} #${current.id}`}
              handleEdit={
                getModelTypeProps(
                  modelType === "type"
                    ? parseModelType(current.model_type)
                    : modelType,
                ).editFunction
              }
              id={current.id}
              onFinish={() => handleDeleteDone(handleClose)}
              isButton
            />
          )}
          {modelType === "email" && !current?.is_ai && (
            <Button
              component={Link}
              to={"/newsletter/create/" + current.id}
              variant="light"
              color="primary"
              radius={"xl"}
              leftSection={<IconSend size={18} />}
            >
              {lang.workflows.program.step_config.more.send_newsletter}
            </Button>
          )}

          <ItemDeleter
            title_bold={`${current.name} #${current.id}`}
            handleDelete={
              getModelTypeProps(
                modelType === "type"
                  ? parseModelType(current.model_type)
                  : modelType,
              ).deleteFunction
            }
            deletedMessage={"Modèle supprimé avec succès"}
            id={current.id}
            disabled={
              !current?.delete_permission &&
              !current?.permission?.delete_permission
            }
            onFinish={() => handleDeleteDone(handleClose)}
            isButton
          />
        </Stack>
      )}
      anchorOrigin={
        inside
          ? { horizontal: "right", vertical: "bottom" }
          : { horizontal: "left", vertical: "center" }
      }
      transformOrigin={
        inside
          ? { horizontal: "right", vertical: "top" }
          : { horizontal: "right", vertical: "center" }
      }
      sx={{ zIndex: "200 !important" }}
    />
  );
};

export default ModelActions;
